import React, { useState } from "react";
import { X } from "lucide-react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const FreeTrial = ({ show, handleClose, pageKey }) => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    website: "",
    contact: ""
  });

  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    e.stopPropagation();
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
  e.stopPropagation();

  if (!formData.fullName || !formData.email || !formData.contact) {
    toast.warning("Please fill all required fields");
    return;
  }

  const payload = {
    fullname: formData.fullName,
    email: formData.email,
    website: formData.website,
    contact: formData.contact
  };

  try {
    setLoading(true);

    const response = await fetch(
      "https://auth.seobix.com/api/Auth/InsertLeads",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      }
    );

    const data = await response.json();

    if (data?.status === "0") {
      toast.success(
        data?.result?.[0]?.message || "Form submitted successfully"
      );

        if (pageKey) {
  sessionStorage.setItem(`freeTrialClosed_${pageKey}`, "true");
}
      setTimeout(() => {
        handleClose();
      }, 1500);

      setFormData({
        fullName: "",
        email: "",
        website: "",
        contact: ""
      });
    } else {
      toast.error("Submission failed. Please try again.");
    }
  } catch (error) {
    console.error(error);
    toast.error("Server error. Please try later.");
  } finally {
    setLoading(false);
  }
};

  const handleModalClose = (e) => {
    e.stopPropagation();
  if (pageKey) {
    sessionStorage.setItem(`freeTrialClosed_${pageKey}`, "true");
  }
    handleClose();
  };

  if (!show) return null;

  return (
    <>
     <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
      />
   
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "1rem"
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        style={{
          maxWidth: "600px",
          width: "100%",
          background: "white",
          borderRadius: "1rem",
          boxShadow: "0 10px 40px rgba(0, 0, 0, 0.2)",
          position: "relative",
          animation: "modalFadeIn 0.3s ease-out"
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <style>{`
          @keyframes modalFadeIn {
            from {
              opacity: 0;
              transform: translateY(-20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}</style>

        <div style={{ padding: "2rem" }}>

          <button
            onClick={handleModalClose}
            style={{
              position: "absolute",
              top: "12px",
              right: "12px",
              width: "36px",
              height: "36px",
              borderRadius: "50%",
              border: "none",
              background: "#f8f9fa",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer"
            }}
          >
            <X size={16} />
          </button>

          <h3
            style={{
              fontWeight: "bold",
              marginBottom: "1rem",
              textAlign: "center",
              color: "#9e104c"
            }}
          >
            Start Your Free Trial
          </h3>

          <p
            style={{
              color: "#6c757d",
              textAlign: "center",
              marginBottom: "1.5rem"
            }}
          >
            Please fill out the form below and we will ensure a personalised demo
            catering to your requirements.
          </p>

          <div style={{ marginBottom: "1rem" }}>
            <label style={{ color: "#9e104c", fontWeight: 500 }}>
              Full Name *
            </label>
            <input
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleInputChange}
              placeholder="Enter Full Name"
              style={inputStyle}
            />
          </div>

          <div style={{ marginBottom: "1rem" }}>
            <label style={{ color: "#9e104c", fontWeight: 500 }}>
              Work Email *
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Enter Work Email"
              style={inputStyle}
            />
          </div>

          <div style={{ marginBottom: "1rem" }}>
            <label style={{ color: "#9e104c", fontWeight: 500 }}>
              Website (Optional)
            </label>
            <input
              type="text"
              name="website"
              value={formData.website}
              onChange={handleInputChange}
              placeholder="www.website.com"
              style={inputStyle}
            />
          </div>

          <div style={{ marginBottom: "1.5rem" }}>
            <label style={{ color: "#9e104c", fontWeight: 500 }}>
              Contact Number *
            </label>
            <input
              type="text"
              name="contact"
              value={formData.contact}
              onChange={handleInputChange}
              placeholder="Contact Number"
              style={inputStyle}
            />
          </div>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <button
              onClick={handleSubmit}
              disabled={loading}
              style={{
                width: window.innerWidth <= 576 ? "100%" : "50%",
                padding: "0.75rem",
                backgroundColor: "#9e104c",
                border: "none",
                borderRadius: "50rem",
                color: "white",
                fontWeight: "500",
                cursor: loading ? "not-allowed" : "pointer",
                opacity: loading ? 0.7 : 1
              }}
            >
              {loading ? "Submitting..." : "Start Free Trial"}
            </button>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

const inputStyle = {
  width: "100%",
  padding: "0.75rem",
  border: "1px solid #ced4da",
  borderRadius: "0.375rem",
  fontSize: "1rem",
  boxSizing: "border-box"
};

export default FreeTrial;
